// extracted by mini-css-extract-plugin
module.exports = {"container":"SessionViewInfoCard_container__RmhL1","cardHeader":"SessionViewInfoCard_cardHeader__1oBbh","hr":"SessionViewInfoCard_hr__2wGDM"};